import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";

function ClearStorageHandler() {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname;

        // Allowed pages
        const isAllowedPage =
            path === "/course-finder" ||
            path === "/part-time-jobs" ||
            matchPath("/program/:id", path) ||
            matchPath("/details/:id", path);

        // Remove storage on other pages
        if (!isAllowedPage) {
            localStorage.removeItem("courseFilters");
            localStorage.removeItem("courseFilterLabels");
            localStorage.removeItem("courseSearch");
            localStorage.removeItem("courseShowSaved");
            localStorage.removeItem("coursePage");

            localStorage.removeItem("jobFilters");
            localStorage.removeItem("jobFilterLabels");
            localStorage.removeItem("jobseSearch");
            localStorage.removeItem("jobPage");
        }
    }, [location.pathname]);

    return null;
}

export default ClearStorageHandler;